import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'utcToLocal',
})
export class UtcToLocalPipe implements PipeTransform {
  private datePipe: DatePipe = new DatePipe('en-US');

  transform(value: string, format: string = 'MM/dd/yyyy, h:mm'): string {
    if (!value) return '';

    // If the value doesn't include a 'Z' or an offset, assume it's UTC by appending 'Z'
    const utcValue =
      value.indexOf('Z') === -1 && value.indexOf('+') === -1
        ? value + 'Z'
        : value;
    const date = new Date(utcValue);

    return this.datePipe.transform(date, format) || '';
  }
}
